export default function Footer() {
  return (
    <footer className="text-white" style={{ backgroundColor: '#3A7AB5' }}>
      {/* メインコンテンツエリア */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {/* 左側: 会社情報 */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/0947c5c75234eb0df91750a621813a72/9e07b5b9673a019b56521029222db271.jpeg"
                alt="株式会社鈴電エンジニア"
                className="h-12 w-auto"
              />
              <span className="text-xl font-bold text-white font-sans">
                株式会社鈴電エンジニア
              </span>
            </div>
            
            <div className="space-y-2 text-white">
              <div className="flex items-start gap-3">
                <div>
                  <p className="font-semibold mb-2 text-base font-sans">会社所在地</p>
                  <p className="text-base leading-relaxed font-sans">
                    〒960-0501 福島県伊達市伏黒字上ケ戸71-6
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 右側: Googleマップ */}
          <div className="w-full h-48 lg:h-full min-h-[200px] rounded-xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2194.583679647772!2d140.53636154856193!3d37.825784403843635!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f8a62b9693dc8f7%3A0xbc582e14bd7d2c34!2z77yI5qCq77yJ6Yi06Zu744Ko44Oz44K444OL44Ki!5e0!3m2!1sja!2sus!4v1766131412113!5m2!1sja!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="株式会社鈴電エンジニア 所在地"
            ></iframe>
          </div>
        </div>
      </div>

      {/* コピーライトエリア */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
          <p className="text-center text-sm text-white/80 font-sans">
            © 2025 株式会社鈴電エンジニア All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}